import React from 'react';
import PropTypes from 'prop-types';

import styles from '../Header.less';
import { DesktopAndTablet, Mobile } from '../../Utils/MediaComponents/MediaComponents';
import userIntents from '../../../userIntents';

export default class HeaderTitle extends React.Component {
  preTitleForSell = 'Immobilienpreise ';

  getPreTitle() {
    switch (this.props.userIntent) {
      case userIntents.BUY:
      case userIntents.SELL:
        return this.preTitleForSell;
      case userIntents.LET:
      case userIntents.RENT:
        return 'Mietpreise ';
      default:
        return '';
    }
  }

  render() {
    return (
      <div className="align-center">
        <Mobile
          render={() => (
            <h1 id="header-headline" className={`${styles.headerTitle} ${styles.headerTitleText} margin-top-xl`}>
              {this.getPreTitle()}
              {this.props.text}
            </h1>
          )}
        />
        <DesktopAndTablet
          render={() => (
            <>
              <h1 id="header-headline" className={`${styles.headerTitle} ${styles.headerTitleText}`}>
                {this.getPreTitle()}
                {this.props.text}
              </h1>
              <h2 id="header-subheadline" className={styles.headerSubTitleText}>
                {this.props.subText}
              </h2>
            </>
          )}
        />
      </div>
    );
  }
}

HeaderTitle.defaultProps = {
  text: null,
  subText: null,
  userIntent: null,
};

HeaderTitle.propTypes = {
  text: PropTypes.string,
  subText: PropTypes.string,
  userIntent: PropTypes.string,
};
